export enum DmsPaths {
    ROOT = "documents",
    EDITING = "editing",
    AVIS = "avis",

    DOCUMENT_ID = "documentId",
}
